import React from "react";
import "./Download.css";

const Download = () => {
  return (
    <section id="download" className="download section">
      <div className="container">
        <div className="download-content text-center">
          <h2>Ready to Shine?</h2>
          <p>Download SyarTech now and give your car the care it deserves</p>
          <div className="download-buttons">
            <a
              href="https://apps.apple.com/us/app/syartech-%D8%B3%D9%8A%D8%A7%D8%B1%D8%AA%D9%83/id6756311895"
              className="store-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>Download on the</span>
              <strong>App Store</strong>
            </a>

            <a
              href="https://play.google.com/store/apps/details?id=com.kamashka.syartechapp"
              className="store-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>Get it on</span>
              <strong>Google Play</strong>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Download;
